exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".alert-54c86{margin-top:-20px;margin-bottom:24px}", ""]);

// Exports
exports.locals = {
	"alert": "alert-54c86"
};